module.exports = __webpack_public_path__ + "img/view.7286c6cf.jpg";